export const FIELD_PATTERN = {
  EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  NAME: /^[\p{L} .'-]+$/u, // Valid for names and last names.
  PASSPORT_NUMBER: /^[a-zA-Z0-9-]+$/, // Alphanumeric characters and hyphens.
};

export const MAX_FIELD_LENGTH = {
  FIRST_NAME: 50,
  LAST_NAME: 50,
};

export const MIN_FIELD_LENGTH = {
  PHONE: 10,
  ZIP_CODE: 3,
};

export const generateFieldPrefixByIndex = <KeyType extends string>(key: KeyType, index: number): `${KeyType}.${number}` => `${key}.${index}`;

/**
 *
 * @example
 * const fieldName = addFieldPrefix()
 * fieldName('firstName') -> 'firstName'
 *
 * const fieldName = addFieldPrefix('passengers')
 * fieldName('firstName') -> 'passengers.firstName'
 * fieldName('lastName') -> 'passengers.lastName'
 */
export function addFieldPrefix(): <Field extends string>(field: Field) => Field;
export function addFieldPrefix<Prefix extends string | undefined>(prefix: Prefix): <Field extends string>(field: Field) => Prefix extends string ? `${Prefix}.${Field}` : Field;
export function addFieldPrefix(prefix?: string) {
  return <Field extends string>(field: Field) => (prefix ? `${prefix}.${field}` : field);
}
